import type { Exercise } from "./schemas/exercise.js";
import type { AthleteTargets, Program } from "./schemas/program.js";
import { programWeeklyPrescription } from "./programPrescription.js";
import { isMuscleUncovered, isScoreableTarget } from "./weeklyTargets.js";

export type ProgramCoverage = {
  /** Muscle slugs, in the athlete's target order. */
  covered: string[];
  uncovered: string[];
};

/**
 * #393: which of the athlete's muscle targets this program trains. One entry
 * per muscle, even with a hard-set and a tonnage target on it. Exercise-axis
 * targets stay out: the prescription is per muscle. Null when the athlete has
 * no muscle target, so the host shows nothing.
 */
export const programCoverage = (
  program: Program,
  catalog: ReadonlyArray<Exercise>,
  targets: AthleteTargets | null,
): ProgramCoverage | null => {
  const muscles = [
    ...new Set(
      (targets?.items ?? [])
        .filter((i) => i.axis === "muscle" && isScoreableTarget(i))
        .map((i) => i.key),
    ),
  ];
  if (muscles.length === 0) return null;
  const prescription = programWeeklyPrescription(program, catalog);
  const covered: string[] = [];
  const uncovered: string[] = [];
  for (const m of muscles) {
    (isMuscleUncovered(prescription, m) ? uncovered : covered).push(m);
  }
  return { covered, uncovered };
};
